import React from "react";
import { Action, Delete } from "../../shared/";
import Update from "./update";
import View from "./view";
import { DELETE_LMBC_HCP } from "./query";

function action(props: any) {
    const { data } = props;

    const actionItems = [
        {
            id: "viewDermatologist",
            name: "View Dermatologist",
            content: <View data={data} />,
        },
        {
            id: "editDermatologist",
            name: "Edit Dermatologist",
            content: <Update formData={data} />,
        },
        {
            id: `deleteDermatologist${data.id}`,
            name: "Delete Dermatologist",
            content: (
                <Delete title="Dermatologist" id={data.id.toString()} query={DELETE_LMBC_HCP} />
            ),
        },
    ];
    return <Action actionTabItems={actionItems} />;
}

export default action;
